import { ApiPoolInfoV4, LiquidityPoolKeysV4 } from '@raydium-io/raydium-sdk';
import { MintTsBackend } from '../utils/mint-ts-backend';
import { PublicKey } from '@metaplex-foundation/js';

export const useBackend = () => {
    const mintTsBackend = new MintTsBackend(process.env.REACT_APP_MINT_TS_BACKEND!, process.env.REACT_APP_MINT_TS_BACKEND_APIKEY!);

    async function getCurrentMint(sessionId: number) {
        return mintTsBackend.getCurrentMint(sessionId);
    }

    async function setCurrentMint(sessionId: number, mint: string) {
        return mintTsBackend.setCurrentMint(sessionId, mint);
    }

    async function parseToken(mint: string) {
        return mintTsBackend.parseToken(mint);
    }

    async function fetchPoolKeys(token: string) {
        const poolKeys = await mintTsBackend.fetchPoolKeys(token);

        const poolPubkeys = {
            id: new PublicKey(poolKeys.id),
            baseMint: new PublicKey(poolKeys.baseMint),
            quoteMint: new PublicKey(poolKeys.quoteMint),
            lpMint: new PublicKey(poolKeys.lpMint),
            baseDecimals: poolKeys.baseDecimals,
            quoteDecimals: poolKeys.quoteDecimals,
            lpDecimals: poolKeys.lpDecimals,
            version: poolKeys.version,
            programId: new PublicKey(poolKeys.programId),
            authority: new PublicKey(poolKeys.authority),
            openOrders: new PublicKey(poolKeys.openOrders),
            targetOrders: new PublicKey(poolKeys.targetOrders),
            baseVault: new PublicKey(poolKeys.baseVault),
            quoteVault: new PublicKey(poolKeys.quoteVault),
            withdrawQueue: new PublicKey(poolKeys.withdrawQueue),
            lpVault: new PublicKey(poolKeys.lpVault),
            marketVersion: poolKeys.marketVersion,
            marketProgramId: new PublicKey(poolKeys.marketProgramId),
            marketId: new PublicKey(poolKeys.marketId),
            marketAuthority: new PublicKey(poolKeys.marketAuthority),
            marketBaseVault: new PublicKey(poolKeys.marketBaseVault),
            marketQuoteVault: new PublicKey(poolKeys.marketQuoteVault),
            marketBids: new PublicKey(poolKeys.marketBids),
            marketAsks: new PublicKey(poolKeys.marketAsks),
            marketEventQueue: new PublicKey(poolKeys.marketEventQueue),
            lookupTableAccount: new PublicKey(poolKeys.lookupTableAccount),
        } as LiquidityPoolKeysV4;

        return poolPubkeys;
    }

    async function setTokenPoolKeys(token: string, poolKeys: LiquidityPoolKeysV4) {
        const stringKeys = {
            id: poolKeys.id.toString(),
            baseMint: poolKeys.baseMint.toString(),
            quoteMint: poolKeys.quoteMint.toString(),
            lpMint: poolKeys.lpMint.toString(),
            baseDecimals: poolKeys.baseDecimals,
            quoteDecimals: poolKeys.quoteDecimals,
            lpDecimals: poolKeys.lpDecimals,
            version: poolKeys.version,
            programId: poolKeys.programId.toString(),
            authority: poolKeys.authority.toString(),
            openOrders: poolKeys.openOrders.toString(),
            targetOrders: poolKeys.targetOrders.toString(),
            baseVault: poolKeys.baseVault.toString(),
            quoteVault: poolKeys.quoteVault.toString(),
            withdrawQueue: poolKeys.withdrawQueue.toString(),
            lpVault: poolKeys.lpVault.toString(),
            marketVersion: poolKeys.marketVersion,
            marketProgramId: poolKeys.marketProgramId.toString(),
            marketId: poolKeys.marketId.toString(),
            marketAuthority: poolKeys.marketAuthority.toString(),
            marketBaseVault: poolKeys.marketBaseVault.toString(),
            marketQuoteVault: poolKeys.marketQuoteVault.toString(),
            marketBids: poolKeys.marketBids.toString(),
            marketAsks: poolKeys.marketAsks.toString(),
            marketEventQueue: poolKeys.marketEventQueue.toString(),
            lookupTableAccount: PublicKey.default.toString(),
        } as ApiPoolInfoV4;

        return mintTsBackend.setPoolKeys(token, stringKeys);
    }

    return { setCurrentMint, getCurrentMint, parseToken, fetchPoolKeys, setTokenPoolKeys };
};
